import http from '@core/fetch'

export default {
  overview: body =>
    http('/p/wedding/index.php/admin/APIMerchantDataStatistics/mealOverview', {
      body
    }),

  trend: body =>
    http('/p/wedding/index.php/admin/APIMerchantDataStatistics/mealDirection', {
      body
    }),

  detail: body =>
    http(
      '/p/wedding/index.php/admin/APIMerchantDataStatistics/mealDetailData',
      {
        body
      }
    )
}
